export default from './discard-post-modal';



// WEBPACK FOOTER //
// ./app/containers/discard-post-modal/index.js